export default function(api: GlobalFetch) {
  return async function(status, objectId, calendarId) {
    const requestBody = {
      switch_status : status? 1:0,
      id_calendar: calendarId,
      id_object: objectId
    }
    const response = await api.fetch(
      `/api/v2/pricemulti/switch`,
      {
        body: JSON.stringify(requestBody),
        method: 'POST',
      },
    )

    if (response.ok) {
      return  response.status
    } else {
      throw new Error(response.status.toString())
    }
  }
}
